// Lecture des codes-barres (zxing-cpp en WebAssembly), chargée à la demande.
// Le fichier .wasm est servi par le site (copié dans public/ au build).
let modPromise = null;

export function chargerLecteur() {
  if (!modPromise) {
    modPromise = import("zxing-wasm/reader").then((m) => {
      m.prepareZXingModule({
        overrides: {
          locateFile: (p, prefix) => (p.endsWith(".wasm") ? `${process.env.PUBLIC_URL || ""}/zxing_reader.wasm` : prefix + p),
        },
        fireImmediately: true,
      });
      return m;
    }).catch((e) => { modPromise = null; throw e; });
  }
  return modPromise;
}

// Seuls les formats des airwaybills : code 128 (FedEx, TNT international),
// ITF (TNT national), PDF417 (étiquette 2D FedEx).
export const OPTIONS_LECTURE = {
  formats: ["Code128", "ITF", "PDF417"],
  tryHarder: true,
  maxNumberOfSymbols: 6,
  textMode: "Plain", // texte brut (séparateurs ␝ ␞ réels, pas de symboles de remplacement)
};

/** Parmi les codes lus, l'airwaybill (FedEx / TNT) ; null si aucun. Les
 * autres codes de l'étiquette (référence, routage, QR…) sont ignorés. En
 * premier : l'étiquette 2D FedEx (n° + adresse). Renvoie aussi les codes
 * ignorés pour l'affichage. */
export function choisirCode(results, lireCode, accepter = null) {
  const accepte = accepter || ((t) => !!lireCode(t).type);
  const ok = (results || []).filter((r) => r.isValid !== false && r.text);
  const awb = ok.filter((r) => accepte(r.text));
  awb.sort((a, b) => (lireCode(b.text).etiquette?.destinataire ? 1 : 0) - (lireCode(a.text).etiquette?.destinataire ? 1 : 0));
  const r = awb[0] || null;
  if (r) {
    r.ignores = ok.filter((x) => !accepte(x.text)).map((x) => x.text);
    r.autres = awb.slice(1); // codes acceptés en plus (mode continu : tous envoyés)
  }
  return r || (ok.length ? { ignore: true, ignores: ok.map((x) => x.text) } : null);
}

// Inventaire du dépôt : codes des chariots (Code 128, Code 39, QR…) en plus
// des airwaybills.
export const OPTIONS_DEPOT = { ...OPTIONS_LECTURE, formats: [...OPTIONS_LECTURE.formats, "Code39", "Code93", "QRCode", "DataMatrix"] };
